const getPercentageValues = (nextValue: number, currentValue: number) =>
  (nextValue - currentValue) / currentValue
export default getPercentageValues
